import ListaCondensacao from "./ListaCondensacao";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function CondensacaoForm() {
    return(
        <AlertDialogOnClose nome={"Condensação"} placeholder={"Insira o nome da condensação"} >
            <ListaCondensacao />
        </AlertDialogOnClose>
    )
} 